import React from 'react';
import PropTypes from 'prop-types';
import { getLog } from '../lib/logger';
import { logger } from '../lib/gaAnalytics';
import ReportErrorPage from './ReportErrorPage';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errormessage: '' };
  }

  static getDerivedStateFromError(error) {
    const log = getLog('ERROR', error.message);
    logger('ERROR', log);

    return { hasError: true, errormessage: JSON.stringify(error.message) };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error caught in boundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <ReportErrorPage errorLog={this.state.errormessage} />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;

ErrorBoundary.propTypes = {
  children: PropTypes.node,
};
